export default function CategoriesGrid() {
  const categories = [
    {
      name: "Shoes",
      description: "Sneakers, boots & more",
      itemCount: "2,400+ items",
      url: "https://kaspreadsheet.com/category-911-Shoes.html",
      image: "https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20elegant%20white%20and%20cream%20athletic%20sneakers%20placed%20on%20a%20light%20terracotta%20ceramic%20tile%20surface%20natural%20daylight%20from%20top%20left%20casting%20subtle%20shadows%20minimalist%20product%20photography%20with%20clean%20composition%20and%20plenty%20of%20empty%20space%20around%20the%20subject&width=600&height=800&seq=cat-v2-shoes-a1&orientation=portrait",
    },
    {
      name: "Hoodies",
      description: "Sweaters & pullovers",
      itemCount: "1,800+ items",
      url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
      image: "https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20sand-colored%20hoodie%20artfully%20draped%20over%20a%20minimalist%20wooden%20chair%20against%20a%20soft%20cream%20wall%20gentle%20morning%20light%20filtering%20through%20sheer%20curtains%20creating%20a%20peaceful%20atmosphere%20editorial%20fashion%20photography%20with%20organic%20textures%20and%20neutral%20tones&width=600&height=800&seq=cat-v2-hoodies-b2&orientation=portrait",
    },
    {
      name: "T-Shirts",
      description: "Graphic & plain tees",
      itemCount: "3,200+ items",
      url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
      image: "https://readdy.ai/api/search-image?query=A%20perfectly%20folded%20crisp%20off-white%20cotton%20t-shirt%20with%20subtle%20texture%20details%20resting%20on%20a%20smooth%20pale%20gray%20concrete%20surface%20soft%20natural%20lighting%20from%20an%20overhead%20skylight%20minimalist%20product%20photography%20with%20clean%20lines%20and%20contemporary%20aesthetic&width=600&height=800&seq=cat-v2-tshirt-c3&orientation=portrait",
    },
    {
      name: "Jackets",
      description: "Coats & outerwear",
      itemCount: "1,500+ items",
      url: "https://kaspreadsheet.com/category-914-Jackets.html",
      image: "https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20khaki%20bomber%20jacket%20hung%20on%20a%20minimalist%20brass%20wall%20hook%20against%20a%20warm%20beige%20plastered%20wall%20soft%20afternoon%20light%20casting%20a%20gentle%20shadow%20to%20the%20right%20editorial%20fashion%20photography%20with%20clean%20composition%20and%20sophisticated%20mood&width=600&height=800&seq=cat-v2-jackets-d4&orientation=portrait",
    },
    {
      name: "Pants",
      description: "Shorts & trousers",
      itemCount: "2,100+ items",
      url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
      image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20tailored%20charcoal%20gray%20trousers%20neatly%20laid%20flat%20on%20a%20light%20bamboo%20woven%20mat%20textured%20surface%20soft%20diffused%20natural%20lighting%20from%20a%20nearby%20window%20minimalist%20product%20photography%20with%20clean%20edges%20and%20contemporary%20style&width=600&height=800&seq=cat-v2-pants-e5&orientation=portrait",
    },
    {
      name: "Headwear",
      description: "Caps & beanies",
      itemCount: "900+ items",
      url: "https://kaspreadsheet.com/category-916-Headwear.html",
      image: "https://readdy.ai/api/search-image?query=A%20classic%20dusty%20pink%20baseball%20cap%20resting%20on%20a%20smooth%20marble%20surface%20with%20subtle%20gray%20veining%20soft%20natural%20light%20from%20top%20right%20creating%20a%20delicate%20shadow%20minimalist%20product%20photography%20with%20elegant%20composition%20and%20feminine%20aesthetic&width=600&height=800&seq=cat-v2-headwear-f6&orientation=portrait",
    },
    {
      name: "Sets",
      description: "Matching outfits",
      itemCount: "600+ items",
      url: "https://kaspreadsheet.com/category-917-Sets.html",
      image: "https://readdy.ai/api/search-image?query=A%20coordinated%20two-piece%20linen%20set%20in%20soft%20olive%20green%20consisting%20of%20a%20button-down%20shirt%20and%20matching%20shorts%20folded%20neatly%20on%20a%20light%20woven%20rattan%20surface%20warm%20natural%20daylight%20from%20the%20side%20creating%20a%20relaxed%20vacation%20vibe%20editorial%20photography&width=600&height=800&seq=cat-v2-sets-g7&orientation=portrait",
    },
    {
      name: "Bags",
      description: "Backpacks & handbags",
      itemCount: "1,200+ items",
      url: "https://kaspreadsheet.com/category-921-Bags.html",
      image: "https://readdy.ai/api/search-image?query=A%20beautiful%20structured%20tan%20leather%20tote%20bag%20standing%20upright%20on%20a%20light%20travertine%20stone%20surface%20against%20a%20soft%20cream%20backdrop%20gentle%20side%20lighting%20highlighting%20the%20leather%20texture%20minimalist%20luxury%20product%20photography%20with%20elegant%20composition%20and%20warm%20tones&width=600&height=800&seq=cat-v2-bags-h8&orientation=portrait",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100" id="categories">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-8 md:mb-10">
          <div>
            <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
              Browse Finds
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Popular <span className="text-primary-500">Categories</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-sm">
            Discover the most sought-after <strong>Kakobuy Spreadsheet</strong> categories with verified finds and trusted sellers.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
              data-product-shop=""
            >
              <img
                src={cat.image}
                alt={`${cat.name} - Kakobuy Spreadsheet`}
                title={`${cat.name} - Kakobuy Spreadsheet`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-foreground-900/10 to-transparent"></div>
              <div className="absolute top-3 left-3 right-3">
                <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                  {cat.itemCount}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-200/80">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
          >
            View All Categories on Kakobuy
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}